"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ClaimBase_1 = require("./ClaimBase");
var RentersClaim = /** @class */ (function (_super) {
    __extends(RentersClaim, _super);
    function RentersClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RentersClaim.getClaimType = function (claimTypeId) {
        switch (claimTypeId) {
            case 10:
                return "Accidental damage";
            case 11:
                return "Accidental loss";
            case 12:
                return "Escape of water/oil";
            case 13:
                return "Earthquake";
            case 14:
                return "Fire";
            case 15:
                return "Flood (river/sea etc.)";
            case 16:
                return "Impact";
            case 17:
                return "Legal liability";
            case 18:
                return "Storm";
            case 19:
                return "Subsidence/heave/landslip";
            case 20:
                return "Theft";
            case 21:
                return "Vandalism";
        }
        throw new Error("Unknown claim type id: ".concat(claimTypeId));
    };
    RentersClaim.claimCount = 12;
    RentersClaim.claimTypeStartId = 10;
    return RentersClaim;
}(ClaimBase_1.default));
exports.default = RentersClaim;
//# sourceMappingURL=RentersClaim.js.map